import { takeLatest, put, call } from 'redux-saga/effects';
import axios from 'app/services/http/axios';

// -------

import { PublicApi } from 'modules/Public';
import {
  signInRequest,
  signInSuccess,
  signInFailed,
} from './slice';

// -------

function* signIn({ payload }) {

  try {
    const response = yield call(axios.post, PublicApi.login, { ...payload });
    yield put(signInSuccess({ ...response, isLogged: true }));

  } catch (e) {
    yield put(signInFailed(e));
  }
}

// -------

export function* watchSignInSaga() {
  yield takeLatest(signInRequest.type, signIn)
}

export default watchSignInSaga
